import React, { useState } from 'react';
import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export default function DuplicateTemplate({ template, onDuplicate, testId }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    if (await onDuplicate(template.template_id, name.trim())) setOpen(false);
  };
  return (
    <>
      <Button size="sm" variant="outline" onClick={() => { setName(`${template.name} (copy)`); setOpen(true); }} data-testid={testId}><Copy className="w-3.5 h-3.5 mr-1.5" /> Duplicate</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-[420px]" data-testid="duplicate-template-dialog">
          <DialogHeader><DialogTitle className="font-['Montserrat']">Duplicate “{template.name}”</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-[#475569]">Creates a new master template with the same Attributes and Factors. The original is not changed.</p>
            <Input autoFocus value={name} maxLength={80} onChange={(e) => setName(e.target.value)} placeholder="New template name" data-testid="duplicate-template-name" />
            <div className="flex justify-end gap-2">
              <Button type="button" variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
              <Button type="submit" disabled={!name.trim()} className="bg-[#1A3E6F] hover:bg-[#15325A]" data-testid="duplicate-template-submit">Duplicate</Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
